// import React, { createContext, useState } from "react";
// import all_product from '../Components/Assets/Frontend_Assets/all_product'

// export const ShopContext = createContext(null);

// const getDefaultCart = () => {
//     let cart = {};
//     for (let i = 0; i < all_product.length; i++) {
//         cart[all_product[i].id] = 0;
//     }
//     return cart;
// };

// const ShopContextProvider = (props) => {

//     const [cartItems, setCartItems] = useState(getDefaultCart());

//     const addToCart = (itemId) => {
//         setCartItems(prev => ({
//             ...prev,
//             [itemId]: prev[itemId] + 1
//         }));
//     };

//     const removeFromCart = (itemId) => {
//         setCartItems(prev => ({
//             ...prev,
//             [itemId]: prev[itemId] - 1
//         }));
//     };

//     // ✅ الدالة المصححة
//     const getTotalCartAmount = () => {
//         let totalAmount = 0;

//         for (const itemId in cartItems) {
//             if (cartItems[itemId] > 0) {
//                 const itemInfo = all_product.find(
//                     product => product.id === Number(itemId)
//                 );

//                 if (itemInfo) {
//                     totalAmount += itemInfo.new_price * cartItems[itemId];
//                 }
//             }
//         }

//         return totalAmount;
//     };

//     const getTotalCartItems = () => {
//         let totalItem = 0;
//         for (const item in cartItems) {
//             if (cartItems[item] > 0) {
//                 totalItem += cartItems[item];

//             }
//         }
//         return totalItem;
//     }

//     const contextValue = {
//         all_product,
//         cartItems,
//         addToCart,
//         removeFromCart,
//         getTotalCartAmount,
// getTotalCartItems
//     };

//     return (
//         <ShopContext.Provider value={contextValue}>
//             {props.children}
//         </ShopContext.Provider>
//     );
// };

// export default ShopContextProvider;


import React, { createContext, useState, useEffect } from "react";
import all_product from '../Components/Assets/Frontend_Assets/all_product';

export const ShopContext = createContext(null);

const getDefaultCart = () => {
    let cart = {};
    for (let i = 0; i < all_product.length; i++) {
        cart[all_product[i].id] = {};
    }
    return cart;
};

const ShopContextProvider = (props) => {
    const [cartItems, setCartItems] = useState(() => {
        const storedCart = localStorage.getItem("cartItems");
        return storedCart ? JSON.parse(storedCart) : getDefaultCart();
    });

    useEffect(() => {
        localStorage.setItem("cartItems", JSON.stringify(cartItems));
    }, [cartItems]);

    const addToCart = (itemId, size) => {
        if (!size) {
            alert("يرجى اختيار مقاس أولاً");
            return;
        }

        setCartItems(prev => ({
            ...prev,
            [itemId]: {
                ...(prev[itemId] || {}),
                [size]: (prev[itemId]?.[size] || 0) + 1
            }
        }));
    };

    const removeFromCart = (itemId, size) => {
        setCartItems(prev => {
            if (!prev[itemId] || !prev[itemId][size]) return prev;

            const newSizes = { ...prev[itemId] };
            if (newSizes[size] > 1) {
                newSizes[size]--;
            } else {
                delete newSizes[size];
            }

            if (Object.keys(newSizes).length === 0) {
                const { [itemId]: _, ...rest } = prev;
                return rest;
            }

            return {
                ...prev,
                [itemId]: newSizes
            };
        });
    };

    const clearCart = () => {
        setCartItems(getDefaultCart());
        localStorage.removeItem("cartItems");
    };

    const getTotalCartAmount = () => {
        let totalAmount = 0;
        for (const itemId in cartItems) {
            const sizes = cartItems[itemId];
            for (const size in sizes) {
                if (sizes[size] > 0) {
                    const itemInfo = all_product.find(p => p.id === Number(itemId));
                    if (itemInfo) {
                        totalAmount += itemInfo.new_price * sizes[size];
                    }
                }
            }
        }
        return totalAmount;
    };

    const getTotalCartItems = () => {
        let total = 0;
        for (const itemId in cartItems) {
            for (const size in cartItems[itemId]) {
                total += cartItems[itemId][size];
            }
        }
        return total;
    };

    const contextValue = {
        all_product,
        cartItems,
        addToCart,
        removeFromCart,
        getTotalCartAmount,
        getTotalCartItems,
        clearCart
    };

    return (
        <ShopContext.Provider value={contextValue}>
            {props.children}
        </ShopContext.Provider>
    );
};

export default ShopContextProvider;

